import React from 'react'
import InteractiveMap from '../../helpers/InteractiveMap'

const TestMap = () => {
  const registeredCoords = {
    lat: 12.9716,
    lng: 77.5946,
  };

  const handleLocationUpdate = (location) => {
    console.log("New location selected:", location);
    console.log("New location selected:", location.latitude);
    // You can save this new location to state or backend
  };
  return (
    <div>
      <InteractiveMap
        initialCoordinates={registeredCoords}
        onLocationSelect={handleLocationUpdate}
      />
    </div>
  )
}

export default TestMap